export enum InternalSessionServiceEventType {
	SESSION_REFRESHED = 'SessionRefreshed',
	SESSION_REPOSITORY_READY = 'SessionRepositoryReady',
}
